<template>
  <div>
    <BaseModal
      v-cloak
      :header-text="$t('Send reminder to submit a bill')"
      :is-open="isOpen"
      :save-state="saveState"
      :cancel-button-text="$t('Cancel')"
      :confirm-button-text="confirmButtonText"
      :saving-text="`${$t('Sending')}...`"
      :saved-text="`${$t('Sent')}!`"
      :modal-id="`remind-to-submit-bill-${hireIds?.[0]}`"
      data-test="remind-to-bill"
      @negative-response="close"
      @cancel="close"
      @positive-response="sendMessage"
    >
      <div class="p-t-15 p-b-15">
        <p>
          {{
            bulkReminder
              ? $t(
                  'If you are missing a bill from the selected contracts, you can prompt reminder emails here',
                )
              : $t(
                  'If you are missing a bill from :freelancer on the contract for :job, you can prompt a reminder email here',
                  { job: jobName, freelancer: freelancerName },
                )
          }}.
        </p>
        <p>
          {{
            bulkReminder
              ? $t('Add an optional message for all recipients')
              : $t('Add an optional message')
          }}:
        </p>
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <base-textarea-autoresize
          v-model="message"
          :placeholder="`${$t('Type your message here')}...`"
          name="message"
          data-test="message-input"
        ></base-textarea-autoresize>
        <p></p>
        <div class="checkbox">
          <div class="checkbox m-t-0 m-b-5">
            <label>
              <input
                v-model="saveAsStandardMessage"
                name="save_as_standard_message"
                type="checkbox"
              />
              <i class="input-helper" />
              {{ $t('Save as default message template') }}
            </label>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { TABLE_BILLS_MUTATIONS } from '@/state/mutation-types'
import BaseModal from '@/components/BaseModal.vue'

export default {
  components: { BaseModal },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    hireIds: {
      type: Array,
      required: true,
    },
    bulkReminder: {
      type: Boolean,
      default: false,
    },
    jobName: {
      type: String,
      default: '',
    },
    freelancerName: {
      type: String,
      default: '',
    },
    defaultMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      saveAsStandardMessage: false,
      message: '',
      saveState: 'fresh',
    }
  },
  computed: {
    confirmButtonText() {
      return this.bulkReminder
        ? $t('Send to selected (:count)', { count: this.hireIds.length })
        : $t('Send')
    },
  },
  mounted() {
    if (this.defaultMessage) {
      this.message = this.defaultMessage
      this.saveAsStandardMessage = true
    }
  },
  methods: {
    close() {
      this.$emit('closed')
    },
    sendMessage() {
      this.saveState = 'saving'
      this.$apollo
        .mutate({
          mutation: gql`
            mutation remindFreelancerToBill(
              $hireIds: [ID]!
              $message: String
              $saveAsStandardMessage: Boolean!
            ) {
              remindFreelancerToBill(
                input: {
                  hires: $hireIds
                  message: $message
                  saveAsStandardMessage: $saveAsStandardMessage
                }
              ) {
                hires {
                  freelancer {
                    localId
                  }
                  hire {
                    localId
                  }
                }
              }
            }
          `,
          variables: {
            hireIds: this.hireIds,
            message: this.message,
            saveAsStandardMessage: this.saveAsStandardMessage,
          },
        })
        .then((result) => {
          if (result?.data?.remindFreelancerToBill?.hires?.length > 0) {
            this.saveState = 'saved'
            const hireIds = Object.values(result?.data?.remindFreelancerToBill?.hires).map(
              (reminderResponse) => reminderResponse.hire.localId,
            )
            setTimeout(() => {
              this.$store.commit(TABLE_BILLS_MUTATIONS.ADD_HIRES_WITH_RECENT_BILL_REMINDER, hireIds)
              this.close()
              this.$emit('reminder-sent')
            }, 1000)
          } else {
            this.saveState = 'failed'
          }
        })
        .catch((error) => {
          this.saveState = 'failed'
        })
        .finally(() => {
          setTimeout(() => {
            this.saveState = 'fresh'
          }, 1000)
        })
    },
  },
}
</script>
